import { motion, useReducedMotion, useScroll, useSpring, useTransform } from "motion/react";
import { useGame } from "../../game/GameContext";
import { BoatLine } from "../art/BoatLine";

/**
 * The voyage rail: a dashed route down the left edge of the viewport with
 * your boat sailing along it as you scroll. Crew otters ride along once
 * mustered. Purely decorative wayfinding; hidden below xl and under
 * reduced motion (the HUD log carries the same progress).
 */
export function VoyageRail() {
  const reduce = useReducedMotion();
  const { started, crew } = useGame();
  const { scrollYProgress } = useScroll();
  const smooth = useSpring(scrollYProgress, { stiffness: 55, damping: 18 });
  /* rail spans from below the HUD to near the viewport bottom */
  const top = useTransform(smooth, (v) => `calc(${(v * 82).toFixed(2)}%)`);

  if (reduce || !started) return null;

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed top-24 bottom-10 left-5 z-40 hidden w-10 2xl:block"
    >
      {/* the route */}
      <span className="absolute top-0 bottom-0 left-1/2 border-l-2 border-dashed border-line" />
      {/* harbour mark at the end of the route */}
      <span className="absolute -bottom-1 left-1/2 size-3 -translate-x-1/2 rounded-full border-2 border-ink bg-signal" />
      {/* the boat, with crew aboard */}
      <motion.div style={{ top }} className="absolute -left-1 w-14">
        <BoatLine className="w-full text-ink" />
        {crew.length > 0 && (
          <span className="absolute -top-1.5 right-1 flex gap-0.5">
            {crew.map((name) => (
              <span key={name} className="block size-1.5 rounded-full bg-ink" />
            ))}
          </span>
        )}
      </motion.div>
    </div>
  );
}
